module.exports = __webpack_public_path__ + "img/RJMT_AD_202202_01_web.9140439b.png";